// Components
import { CardContainer as Card } from "../../../components/Card/CardContainer";
import Section from "../../../components/Section/SectionContainer";

// CSS
import styles from "../video.module.scss";

const VideoRelated = (props) => {
    const { history, videos } = props;

    function handleSelect(video) {
        history.push({ pathname: `/videos/${video.id}`, state: { video } });
        history.go(0);
    }

    return (
        <Section classes={styles.related}>
            <h1 className={styles.header}>Related Content</h1>
            <div className={styles.grid}>
                <Card
                    data={videos[0]}
                    onClick={() => handleSelect(videos[0])}
                />
                <Card
                    data={videos[1]}
                    onClick={() => handleSelect(videos[1])}
                />
                <Card
                    data={videos[2]}
                    onClick={() => handleSelect(videos[2])}
                />
            </div>
        </Section>
    );
};

export default VideoRelated;
